const setting = {
  passwordTitle: "Senha",
  changePasswordBtn: "Alterar Senha",
  changePasswordTips:
    "Se você esquecer sua senha ou quiser alterá-la, você pode fazê-lo aqui; enviaremos um código de verificação para seu e-mail registrado, que deverá ser verificado para confirmar sua identidade, e então você poderá redefinir a senha de sua conta.",
  feedbackTitle: "Feedback",
  feedbackBtn: "Enviar Feedback",
  feedbackTips:
    "Para que possamos atendê-lo melhor, você pode descrever seu problema aqui e enviá-lo para nós como feedback, e nossa equipe de suporte entrará em contato com você o mais rápido possível.",
  appearanceTitle: "Aparência",
  appearanceBtn: "Mudar Aparência",
  appearanceTips:
    "Escolhemos dois modos de aparência para você, assim você pode alternar entre os modos escuro e claro, de acordo com sua preferência.",
  changePassWordModalTitle: "Alterar Senha",
  changePassWordSameErrorTips: "A nova senha que você inseriu é a mesma que sua senha antiga. Digite uma senha diferente",
  changePasswordCurrentErrorTips: "Sua senha é incorreta. Por favor, tente novamente.",
  currentPasswordLabel: "Senha Atual",
  newPasswordLabel: "Nova senha",
  retypePasswordLabel: "Digite novamente a nova senha",
  changePasswordSuccessTips: "Sua senha foi alterada com sucesso.",
  changePasswordComfirmDiffErrorTips: "Por favor, digite a mesma senha em ambos os campos.",
  forgotPassword: "Esqueceu Senha?",
  feedbackModalSubtitle: "Obrigado por entrar em contato conosco e nos dizer sua opinião sobre o produto!",
  feedBackModalProductQuestion: "Que tipo de problemas você quer resolver com nosso produto?",
  feedBackModalProductTypeSug: "Sugestões",
  feedBackModalProductTypeMem: "Perguntas relacionadas aos serviços de membro",
  feedBackModalProductTypeFun: "Consulta de funções",
  feedBackModalProductTypeReq: "Requisitos de produto",
  feedBackModalProductTypeBug: "Feedback sobre bugs de produtos",
  feedBackModalProductTypeIss: "Questões de desempenho de produto",
  feedBackModalProductTypeRL: "Perguntas relacionadas ao registro e login",
  feedBackModalProductTypeRef: "Serviço de reembolso",
  feedBackModalProductTypeOth: "Outros",
  feedBackModalProductSelectQuestion: "Que tipo de problemas você quer resolver com nosso produto?",
  feedBackModalProductContQuestion: "Qual foi o problema que você encontrou ao usar o produto?",
  feedBackModalAddImageBtn: "Adicionar imagens",
  feedBackModalTips: "Dicas:",
  feedBackModalTipsCont: "Devido à diferença de horário do atendimento ao cliente global, responderemos dentro de 48 horas a partir do dia útil.",
  feedBackSuccessTips: "Enviado com sucesso",
  feedBackSuccessSubTips: "Resolveremos seu problema o mais rápido possível",
  feedBackFailedTips: "Falha ao enviar",
  feedBackFailedSubTips: "Por favor, verifique se sua conexão de rede está bem e envie novamente",
  appearanceLightMode: "Modo Claro",
  appearanceDarkMode: "Modo Escuro",
  promotionModalTitle: "Promoção",
  promoItem: "Item de Promoção",
  promoCode: "Código de Promoção",
  discount: "Desconto",
  applyBtn: "Aplicar",
  applyPromotionErrorTips: "Seu código de promoção é inválido",
};

export default setting;
